<form [formGroup]="conditionForm">
  <p class="radio-title">Har telefonen noen skader eller problemer?</p>
  <div class="radio-wrapper">
    <app-ice-radio-button
      forId="is-damaged-yes"
      formControlName="isPhoneDamaged"
      ngDefaultControl
      testId="is-phone-damaged-yes-input"
      [isBoxVersion]="true"
      [label]="isPhoneDamagedOptions.YES"
      [value]="isPhoneDamagedOptions.YES"
    />
    <app-ice-radio-button
      forId="is-damaged-no"
      formControlName="isPhoneDamaged"
      ngDefaultControl
      testId="is-phone-damaged-no-input"
      [isBoxVersion]="true"
      [label]="isPhoneDamagedOptions.NO"
      [value]="isPhoneDamagedOptions.NO"
    />
  </div>
  <app-information-button
    [activeLabel]="'Skjul informasjon'"
    [inactiveLabel]="'Hva menes med skader på telefonen?'"
    (toggleInfo)="togglePhoneHasDamage()"
  />

  @if (!hasInsurance) {
    @if (isPhoneDamaged.value !== isPhoneDamagedOptions.YES) {
      <app-ice-alert type="info" [iconName]="IconNames.ice_info">
        <b>Ingen forsikring</b>
        <br />
        Denne avtalen har ikke forsikring. Eventuell reperasjon av mobil må være gjennomført hos en godkjent reparatør før
        innbytte.
      </app-ice-alert>
    } @else {
      <app-ice-alert type="error" [iconName]="IconNames.ice_warning">
        <b>Mobilen har skader som må repareres</b>
        <br />
        Denne avtalen har ikke forsikring, så telefonen må repareres hos en godkjent reparatør før innbytte.
      </app-ice-alert>
    }
  }

  @if (isPhoneDamaged.value === isPhoneDamagedOptions.YES && hasInsurance) {
    @if (damageReasons().length > 0) {
      <p class="damage-reason-title">
        Hva slags skade har telefonen?
        @if (showDamageReasonsRequiredError) {
          <span>*Påkrevd</span>
        }
      </p>
      @for (reason of damageReasons(); track reason.code) {
        <app-ice-select-box
          type="checkbox"
          [control]="damageReasonsFormArray"
          [label]="reason.description"
          [value]="reason.code"
        />
      }
      @if (showDamageReasonsRequiredError) {
        <div class="error-section">
          <mat-icon [svgIcon]="IconNames.ice_warning" />
          <span>Velg minst én skade</span>
        </div>
      }
    }
    <app-ice-date-picker
      buttonTestId="date-of-damage-button"
      errorText="Datoen du har valgt er ikke tillatt"
      formControlName="dateOfDamage"
      label="Skadedato"
      ngDefaultControl
      textTestId="date-of-damage-input"
      [errorOnTouchedOnly]="true"
      [maxDate]="today"
      [minDate]="oneYearAgo"
    />
    <p class="insurance-disclaimer">Forsikringen gjelder kun ett år tilbake i tid</p>
    <app-ice-textarea
      class="explanation-of-damage"
      forId="explanation-of-damage"
      formControlName="explanationOfDamage"
      label="Forklar kort hva som skjedde"
      longHelpText="Forsikringen krever informasjon om hvordan skaden oppstod."
      ngDefaultControl
      placeholder="F.eks hvor var kunden da skaden oppstod"
      rows="2"
      testId="explanation-of-damage-input"
      [errorOnTouchedOnly]="true"
    />
    <p class="confirm-damage-title">Bekreft ekstern skade</p>
    <app-ice-checkbox
      errorText="Forsikringen dekker kun skader som skyldes en plutselig og ytre hendelse - ikke feilbruk eller tilsiktet skade."
      forId="is-external-damage"
      label="Enheten gikk i stykker på grunn av ekstern hendelse eller skade"
      ngDefaultControl
      testId="is-external-damage-input"
      [errorOnTouchedOnly]="true"
      [formControl]="confirmationOfExternalDamage"
    />
  }
</form>
